import { configureStore } from '@reduxjs/toolkit'
import sessionReducer from './slices/session-slice'
import userReducer from './slices/user-slice'
import logsReducer from './slices/logger-slice';

export default configureStore({
    reducer: {
        session: sessionReducer,
        user: userReducer,
        logs: logsReducer
    },
})